import Error from '../model/Error';
import ExportLog from '../dto/ExportLog';
import axios from 'axios';

export default class ExportLogRepository {

    static find(exportLogId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/export-logs/${exportLogId}`)
                .then(response => resolve(ExportLog.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
